export default __webpack_public_path__ + "static/favicon-682dbc6a6ba047487a61894d6a92fc96.ico";